var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="customSchemaSchema_empty"> <div id="customSchemaSchemaListItemHeader"></div> <div id="customSchemaSchemaList"></div> <div style="height:10px"></div> <div id="customSchemaSchemaInsert"></div> </div>';
}
return __p;
};
